import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { colors } from 'common/constants';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { CampaignContainer } from '../campaign-overview/campaign-container';
import { useNavigate, useParams } from 'react-router-dom';
import { createStyleSheet, handleError } from 'utils/helpers';
import { useAppSelector, useAppDispatch } from 'common/hook';
import CampaignConstants from 'pages/admin/campaign/constants';
import { activeSurveyFree } from 'services/campaign.service';
import { setCampaign } from 'slices/campaignsSlice';
import { toast } from 'react-toastify';
import { campaignsResponseFormatter } from 'utils/campaign_helpers';
import { useTranslation } from 'react-i18next';
import { resetSurveyPayment } from 'slices/paymentSlice';
import CampaignStatus from '../campaign/components/campaign-status';

const CampaignDataCollection: React.FC = () => {
    const navigate = useNavigate();
    const { id: campaignId } = useParams();
    const currentCampaign = useAppSelector(
        (state) => state.campaignState.campaign
    );
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    useEffect(() => {
        if (!currentCampaign) return;
        if (
            currentCampaign?.status_client !==
            CampaignConstants.status.CLIENT_DRAFT
        ) {
            navigate(
                `/admin/campaign/data-collect/${campaignId}/survey-active`
            );
        }
    }, [currentCampaign, campaignId, navigate]);

    const handleSurveyFree = async () => {
        try {
            if (!currentCampaign) return;
            const response = await activeSurveyFree(currentCampaign.id);
            if (response.success) {
                dispatch(
                    setCampaign(campaignsResponseFormatter(response.data, t))
                );
                navigate(
                    `/admin/campaign/data-collect/${campaignId}/survey-active`
                );
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    };

    return (
        <CampaignContainer>
            <Box
                sx={{
                    marginBottom: '68px',
                }}
            >
                <Box sx={{ textAlign: 'center', width: '100%' }}>
                    <Box
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 2,
                            maxWidth: '100%',
                            flexWrap: 'wrap',
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 600,
                                fontSize: '40px',
                                color: colors.main,
                                lineHeight: '48.41px',
                                wordBreak: 'break-word',
                            }}
                        >
                            {currentCampaign?.campaign}
                        </Typography>

                        <CampaignStatus
                            status={currentCampaign?.status_client as string}
                        />
                    </Box>
                </Box>
            </Box>
            {currentCampaign &&
                currentCampaign.status_client ===
                    CampaignConstants.status.CLIENT_DRAFT && (
                    <Box sx={styles.boxContainter}>
                        <Box onClick={handleSurveyFree} sx={styles.boxItem}>
                            <Typography variant="h4" sx={styles.boxItemTitle}>
                                Khảo sát miễn phí
                            </Typography>
                            <CheckCircleIcon
                                sx={{
                                    fontSize: 120,
                                    color: 'var(--color-primary)',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '38px',
                                    color: colors.main,
                                    marginBottom: '42px',
                                    lineHeight: '45.99px',
                                }}
                            >
                                Xác nhận
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={styles.boxItemContent}
                            >
                                Nếu bạn đã hoàn tất, hãy nhấn nút xác nhận để
                                kích hoạt khảo sát và lấy đường dẫn chia sẻ đến
                                bạn bè. Lưu ý khảo sát đã kích hoạt sẽ không thể
                                thêm hoặc bớt câu hỏi và câu trả lời.
                            </Typography>
                        </Box>
                        <Box
                            sx={styles.boxItem}
                            onClick={() => {
                                dispatch(resetSurveyPayment());
                                navigate(
                                    `/admin/campaign/data-collect/${campaignId}/service-payment`
                                );
                            }}
                        >
                            <Typography variant="h4" sx={styles.boxItemTitle}>
                                Dịch vụ khảo sát
                            </Typography>
                            <RocketLaunchIcon
                                sx={{
                                    fontSize: 120,
                                    color: 'var(--color-primary)',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '38px',
                                    color: colors.main,
                                    marginBottom: '42px',
                                    lineHeight: '45.99px',
                                }}
                            >
                                Sử dụng
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={styles.boxItemContent}
                            >
                                Nếu bạn mệt mỏi khi năn nỉ người khác trả lời
                                khảo sát? Chúng tôi sẽ gửi bảng câu hỏi khảo sát
                                đến đúng đối tượng bạn cần. SurveyTrue cam kết
                                đảm bảo chất lượng dữ liệu và hoàn thành đúng
                                thời hạn.
                            </Typography>
                        </Box>
                    </Box>
                )}
        </CampaignContainer>
    );
};
const styles = createStyleSheet({
    boxContainter: {
        display: 'flex',
        justifyContent: 'center',
        gap: '4rem',
    },
    boxItem: {
        width: '615px',
        height: '654px',
        backgroundColor: (theme) => theme.palette.common.white,
        borderRadius: '30px',
        boxShadow: '0px 0px 10px 0px #00000040',
        padding: '52px',
        textAlign: 'center',
        cursor: 'pointer',
    },
    boxItemTitle: {
        fontWeight: 600,
        fontSize: '38px',
        marginBottom: '76px',
    },
    boxItemContent: {
        fontWeight: 400,
        fontSize: '22px',
        lineHeight: '26.63px',
    },
});
export default CampaignDataCollection;
